<template>
  <div class="white-background-wrap">
    <div class="social">
      <h2 class="section-header">Social Media</h2>
      <p>Check my social media links, follow me to stay updated</p>
      <a href="https://twitter.com/LowcoTV" title="Twitter" target="_blank" rel="noopener" class="link-wrap" :aria-label="twitterCount + ' twitter followers'">
        <icon name="twitter" class="icon" :scale="iconSize+0.25"></icon>
        <label>Twitter</label>
        <span>{{twitterCount}} followers</span>
      </a>
      <a href="https://discord.gg/Lowco" title="Discord" target="_blank" rel="noopener" class="link-wrap" :aria-label="discordCount + ' discord members'">
        <icon name="discord" class="icon" :scale="iconSize"></icon>
        <label>Discord</label>
        <span>{{discordCount}} members</span>
      </a>
      <a href="https://www.youtube.com/user/Lowco2525" title="Youtube" target="_blank" rel="noopener" class="link-wrap" :aria-label="youtubeCount + ' Lowco Games youtube subscribers'">
        <icon name="youtube-play" class="icon" :scale="iconSize+0.25"></icon>
        <label>LowcoGames</label>
        <span>{{youtubeCount}} subscribers</span>
      </a>
      <a href="https://www.youtube.com/channel/UC3GZtOeb7Pe2HVYYPk6ilnA" title="Youtube" target="_blank" rel="noopener" class="link-wrap" :aria-label="youtube2Count + ' Lowco youtube viewers'">
        <icon name="youtube-play" class="icon" :scale="iconSize+0.25"></icon>
        <label>Lowco</label>
        <span>{{youtube2Count}} subscribers</span>
      </a>
      <a href="https://www.instagram.com/lowco2525/" title="Instagram" target="_blank" rel="noopener" class="link-wrap" :aria-label="instagramCount + ' instagram followers'">
        <icon name="instagram" class="icon" :scale="iconSize"></icon>
        <label>Lowco2525</label>
        <span>{{instagramCount}} followers</span>
      </a>
      <a href="https://www.instagram.com/lowcotv/" title="Instagram" target="_blank" rel="noopener" class="link-wrap" :aria-label="instagram2Count + ' instagram followers'">
        <icon name="instagram" class="icon" :scale="iconSize"></icon>
        <label>LowcoTV</label>
        <span>{{instagram2Count}} followers</span>
      </a>
      <a href="https://www.twitch.tv/lowco" title="Twitch" target="_blank" rel="noopener" class="link-wrap" :aria-label="twitchCount + ' twitch followers'">
        <icon name="twitch" class="icon" :scale="iconSize"></icon>
        <label>Twitch</label>
        <span>{{twitchCount}} followers</span>
      </a>
    </div>
  </div>
</template>

<script>
import SocialMediaIcons from '../header/SocialMediaIcons'
import twitter from '../../gateways/twitter'
import youtube from '../../gateways/youtube'
import twitch from '../../gateways/twitch'
export default {
  name: 'Social',
  components: {SocialMediaIcons},
  methods: {
    formatNumber: function (num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  },
  created: function () {
    twitter.getUser().then(function (results) {
      this.twitterCount = this.formatNumber(results.body.followers_count)
    }.bind(this))
    youtube.getSubscribers().then(function (results) {
      for (let i = 0; i < results.body.items.length; i++) {
        switch (results.body.items[i].id) {
          case 'UC3GZtOeb7Pe2HVYYPk6ilnA': // Lowco Not Games
            this.youtube2Count = this.formatNumber(results.body.items[i].statistics.subscriberCount)
            break
          case 'UCIE_BvU71U28q6It6F6dl0g': // Lowco Games
            this.youtubeCount = this.formatNumber(results.body.items[i].statistics.subscriberCount)
            break
        }
      }
    }.bind(this))
    twitch.getChannelInfo(52925091).then(function (results) {
      this.twitchCount = this.formatNumber(results.body.total)
    }.bind(this))
  },
  data () {
    return {
      iconSize: 3,
      twitterCount: '32,000',
      youtubeCount: '22,000',
      youtube2Count: '3,000',
      instagramCount: '6,300',
      instagram2Count: '330',
      discordCount: '2,300',
      twitchCount: '100,000'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../variables.scss';
  .social{
    padding: $home-section-padding;
  }
  .icon{
    display: block;
    fill: $light-purple;
    transition: $standard-transition;
    margin: 0 auto;
  }
  .link-wrap{
    display: inline-block;
    padding: $standard-spacing;
    text-align: center;
    border-radius: 20px;
    margin: $standard-spacing;
    transition: $standard-transition;
    label{
      color: $font-gray;
      transition: $standard-transition;
    }
    span{
      display: block;
      color: $light-purple;
      margin-top: 2px;
    }
    &:hover, &:focus{
      background-color: $light-purple;
      transform: scale(1.1);
      label, span{
        color: $font-white;
      }
      .icon{
        fill: $font-white;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Social.vue?1e25ebf5